import React, { useCallback, useEffect } from 'react'
import { connect } from 'react-redux'
import { setItem } from '../../actions'

import makePath from '../../utils/makePath'

import { ImageUpload, TextInput} from '../EditorFormElements'
import { FormFieldWrapper } from '../Global'


export const UnconnectedPathChoice = React.memo(({callback:propsCallback,given={},index,setItem, ...props}) => {
  const path = makePath(props.path,index)
  
  useEffect(() => {
    setItem(makePath(path,'correct'), true)
  }, [setItem,path])

  const callback = useCallback((name,value) => {    
    if (typeof value !== 'string') {
      if (value.alt) {
        value = value.alt
      }
      else {
        value = `Path ${index} (Provide alt text)`
      }
    }
    propsCallback(index, value);
  }, [propsCallback, index])


  const renderChoiceType = () => {
    if (props.format === 'text') {
      return <TextInput 
              name="text"
              given={given.text}
              multiline
              rows={2}
              label="Answer Choice"
              placeholder="Provide text to display as an answer option."
              defaultText="Enter answer choice text"
              path={path}
              callback={callback}
            />
    }
    else if (props.format === 'image') {
      return <ImageUpload 
                name="image"
                given={given.image}
                label="Answer Choice Image"
                tooltip="Upload an image to display as the answer choice. Must not exceed 330px in width and not exceed 75KB."
                includeAlt={true}
                altLabel="Image Alt Text"
                altPlaceholder="Provide image alt text that describes image to support screen readers."
                path={path}
                callback={callback}
              /> 
    } else {
      return <div></div>
    }

  }

  return (
    <>
    
      {/* <div className={`${classes.pathPill} ${classes['pathPill' + index]}`}>Path {index + 1}</div> */}
      <div className={`path-pill path-pill--${index}`}>Path {index + 1}</div>

      <FormFieldWrapper>
      
        { renderChoiceType() }

        <TextInput 
          multiline
          rows={2}
          label="Answer Feedback"
          name="feedback"
          given={given.feedback}
          placeholder="Provide text to display as feedback."
          path={path}
        /> 

      </FormFieldWrapper>

    </>
  )

})

export const PathChoice = connect(null, ({setItem}))(UnconnectedPathChoice)